import { capitalize, toLower } from 'lodash';
import { useCallback, useMemo } from 'react';

const useAlertLevelConfigs = (alertLevels = []) => {
  // Format alert level options
  const formatAlertLevelOptions = useCallback(
    (withAllOptions = false) => {
      const options = alertLevels.map(({ code, displayName }) => ({
        label: displayName || capitalize(code),
        value: code
      }));

      return withAllOptions
        ? [{ label: 'All', value: '' }, ...options]
        : options;
    },
    [alertLevels]
  );

  // Get level label
  const getLevelLabel = useCallback(
    (levelCode) => {
      const alertLevel = alertLevels.find(
        ({ code }) => toLower(code) === toLower(levelCode)
      );

      return alertLevel?.displayName || capitalize(levelCode);
    },
    [alertLevels]
  );

  // Get level color
  const getLevelColor = useCallback(
    (levelCode) => {
      const alertLevel = alertLevels.find(
        ({ code }) => toLower(code) === toLower(levelCode)
      );

      return alertLevel?.color;
    },
    [alertLevels]
  );

  // format alertlevel for CRS. CRS has "medium" instead of "good".
  const crsAlertLevels = useMemo(() => {
    return alertLevels.map((level) =>
      toLower(level?.code) === 'good' ? { ...level, code: 'Medium' } : level
    );
  }, [alertLevels]);

  // Get level label for CRS
  const getCRSLevelLabel = useCallback(
    (levelCode) => {
      const alertLevel = crsAlertLevels.find(
        ({ code }) => toLower(code) === toLower(levelCode)
      );

      return alertLevel?.displayName || capitalize(levelCode);
    },
    [crsAlertLevels]
  );

  // Get level color for CRS
  const getCRSLevelColor = useCallback(
    (levelCode) => {
      const alertLevel = crsAlertLevels.find(
        ({ code }) => toLower(code) === toLower(levelCode)
      );

      return alertLevel?.color;
    },
    [crsAlertLevels]
  );

  return {
    formatAlertLevelOptions,
    getLevelLabel,
    getLevelColor,
    crsAlertLevels,
    getCRSLevelLabel,
    getCRSLevelColor
  };
};

export default useAlertLevelConfigs;
